<template>
  <div class="recommend-page" v-loading="isLoading">
    <crumbs title="首页推荐" />
    <div
      class="recommend-page__item"
      v-for="(data, idx) in queryList"
      :key="idx"
    >
      <div class="recommend-page__title">
        <span>{{ titleList[idx] }}</span>
      </div>
      <div class="row" v-for="(item, index) in data.dataList" :key="index">
        <div class="title">{{ item.type }}：</div>
        <div class="name" @click="handleData(item)">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecommendHomepage",
  data() {
    return {
      //是否处于loading状态
      isLoading: true,
      titleList: [
        "成果转化-技术类成果（首页展示）",
        "成果转化-产品类成果（首页展示）",
        "企业需求（首页展示）",
        "知识产权（首页展示）",
        "创新活动（活动列表页展示）",
        "新闻资讯（首页展示+新闻列表页展示）"
      ],
      queryList: []
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    handleData(params) {
      const { name, type, relationType } = params;
      if (name === "未推荐") {
        switch (relationType) {
          case 1:
            this.redirectByPath(`/admin/recommendManage/recommendAch`, {
              achvType: 1,
              method: "homepage",
              type,
              relationType
            });
            break;
          case 2:
            this.redirectByPath(`/admin/recommendManage/recommendAch`, {
              achvType: 2,
              method: "homepage",
              type,
              relationType
            });
            break;
          case 3:
            this.redirectByPath(`/admin/recommendManage/recommendDem`, {
              method: "homepage",
              type,
              relationType
            });
            break;
          case 4:
            this.redirectByPath(`/admin/recommendManage/recommendPatent`, {
              method: "homepage",
              type,
              relationType
            });
            break;
          case 5:
            this.redirectByPath(`/admin/recommendManage/recommendAct`, {
              method: "homepage",
              type,
              relationType
            });
            break;
          case 6:
            this.redirectByPath(`/admin/recommendManage/recommendNews`, {
              method: "homepage",
              type,
              relationType
            });
            break;
        }
      } else {
        // 取消
        this.handleCancel(params);
      }
    },
    //取消推荐
    handleCancel(params) {
      const { name, type } = params;
      this.$confirm("是否取消当前推荐？", type + "：" + name, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadCancel(params);
        })
        .catch(() => {});
    },
    loadCancel(params) {
      this.$api("recommend", "cancelHomepage", params).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    // 加载数据接口
    loadList() {
      this.isLoading = true;
      this.$api("recommend", "getHomepageList", {}).then((res) => {
        this.isLoading = false;
        this.queryList = res.dataList;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.recommend-page {
  &__title {
    height: 25px;
    padding-left: 20px;
    border-left: 3px solid #409eff;
    margin-bottom: 25px;
    line-height: 25px;
    color: #409eff;
  }
  &__item {
    padding: 30px 60px 10px;
    margin-bottom: 10px;
    background: #fff;
  }
  .row {
    display: flex;
    align-items: center;
    height: 40px;
    margin-bottom: 22px;
    font-size: 14px;
    color: #333;
    .title {
      flex: 0 0 100px;
      text-align: right;
    }
    .name {
      margin-left: 2em;
      cursor: pointer;
    }
  }
}
</style>
